import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import RealTimeCounters from './components/RealTimeCounters';
import BusinessBenefits from './components/BusinessBenefits';
import QRFeatureDemo from './components/QRFeatureDemo';
import MembershipTiers from './components/MembershipTiers';
import BizznetRewards from './components/BizznetRewards';
import AffiliateProgram from './components/AffiliateProgram';
import PointsSystemSection from './components/PointsSystemSection';
import AffiliateCTA from './components/AffiliateCTA';
import TestimonialCarousel from './components/TestimonialCarousel';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const LandingPage = () => {
  const mockUser = null;

  return (
    <div className="min-h-screen bg-background">
      <Header user={mockUser} />
      
      <main>
        <HeroSection />
        <RealTimeCounters />
        <BusinessBenefits />
        <QRFeatureDemo />
        <MembershipTiers />
        <BizznetRewards />
        <AffiliateProgram />
        <PointsSystemSection />
        <AffiliateCTA />
        <TestimonialCarousel />
        <CTASection />
      </main>

      <Footer />
    </div>
  );
};

export default LandingPage;